// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ion-header {
  box-shadow: none;
}

.home-page-toolbar-right {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.lang-icon {
  font-size: 1.5rem;
  color: var(--ion-color-medium-grey);
  margin-right: 0.4rem;
  cursor: pointer;
}

.lang-hover {
  --background-hover: transparent;
  --border-radius: 48px;
}
@media (max-width: 1124px) {
  .lang-hover {
    display: none;
  }
}

.lang-text {
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5rem;
  letter-spacing: 0.15px;
  color: var(--ion-color-dark-grey);
}
@media (max-width: 576px) {
  .lang-text {
    font-size: 0.875rem;
  }
}

.avatar-arrow-icon {
  color: var(--ion-color-medium-grey);
  cursor: pointer;
}
@media (max-width: 810px) {
  .avatar-arrow-icon {
    display: none;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/components/app-header/app-header.component.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AACF;;AAEA;EACE,iBAAA;EACA,mCAAA;EACA,oBAAA;EACA,eAAA;AACF;;AAEA;EACE,+BAAA;EACA,qBAAA;AACF;AACE;EAJF;IAKI,aAAA;EAEF;AACF;;AACA;EACE,mBAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,iCAAA;AAEF;AAAE;EAPF;IAQI,mBAAA;EAGF;AACF;;AAAA;EACE,mCAAA;EACA,eAAA;AAGF;AADE;EAJF;IAKI,aAAA;EAIF;AACF","sourcesContent":[":host ion-header {\n  box-shadow: none;\n}\n\n.home-page-toolbar-right {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.lang-icon {\n  font-size: 1.5rem;\n  color: var(--ion-color-medium-grey);\n  margin-right: 0.4rem;\n  cursor: pointer;\n}\n\n.lang-hover {\n  --background-hover: transparent;\n  --border-radius: 48px;\n\n  @media(max-width: 1124px) {\n    display: none;\n  }\n}\n\n.lang-text {\n  font-size: 0.875rem;\n  font-weight: 400;\n  line-height: 1.5rem;\n  letter-spacing: 0.15px;\n  color: var(--ion-color-dark-grey);\n\n  @media(max-width: 576px) {\n    font-size: 0.875rem;\n  }\n}\n\n.avatar-arrow-icon {\n  color: var(--ion-color-medium-grey);\n  cursor: pointer;\n\n  @media(max-width: 810px) {\n    display: none;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
